import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const Download01Icon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <path
      d="M16.75 11.4167V12.4833C16.75 13.9768 16.75 14.7235 16.4594 15.294C16.2037 15.7957 15.7957 16.2037 15.294 16.4594C14.7235 16.75 13.9768 16.75 12.4833 16.75H5.01667C3.52319 16.75 2.77646 16.75 2.20603 16.4594C1.70426 16.2037 1.29631 15.7957 1.04065 15.294C0.75 14.7235 0.75 13.9768 0.75 12.4833V11.4167M13.1944 6.97222L8.75 11.4167M8.75 11.4167L4.30556 6.97222M8.75 11.4167V0.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
